"use strict";

exports.__esModule = true;
exports.buildGroups = exports.filterDisabled = exports.idMap = exports.getNotSelected = exports.getSelected = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelected = function getSelected(users) {
  return users.filter(function (usr) {
    return usr.selected;
  });
};

exports.getSelected = getSelected;

var getNotSelected = function getNotSelected(users) {
  return users.filter(function (usr) {
    return !usr.selected;
  });
};

exports.getNotSelected = getNotSelected;

var idMap = function idMap(user) {
  return user.id;
};

exports.idMap = idMap;

var filterDisabled = function filterDisabled(user) {
  return !user.disabled;
};

exports.filterDisabled = filterDisabled;

var buildGroups = function buildGroups(users, groupBy) {
  if (!groupBy) {
    return {
      'All employees': users
    };
  }

  return users.reduce(function (obj, user) {
    var groupings = (0, _lodash.default)(user, groupBy, 'No group');

    if (Array.isArray(groupings) && groupings.length === 0) {
      groupings = 'No group';
    }

    if (typeof groupings === 'string') {
      groupings = [groupings];
    }

    groupings.forEach(function (group) {
      obj[group] = obj[group] || [];
      obj[group].push(user);
    });
    return obj;
  }, {});
};

exports.buildGroups = buildGroups;